import PropTypes from 'prop-types';

import {copyableProperty} from '../common';

/**
 * Display value for 2nd level category
 */
export const secondLevelCategory = (event) => copyableProperty(
    {
        data: event,
        nonSr: ['content_category', 'parent'],
    },
    'Content category'
);

secondLevelCategory.propTypes = {
    event: PropTypes.object.isRequired,
};
